import { boundsForTiles } from '../shared/geometry.js';
import type { MosaicDevice, TileLayout } from '../shared/protocol.js';
import { relativeRotation } from './device-orientation.js';

export function sensorAssistedRow(
  devices: MosaicDevice[],
  gap = 24
): Array<{ deviceId: string; layout: TileLayout }> {
  const ordered = [...devices].sort((left, right) => left.label.localeCompare(right.label));
  const reference = ordered.find((device) => device.orientation)?.orientation?.heading;
  let cursor = 0;

  return ordered.map((device) => {
    const rotation =
      reference !== undefined && device.orientation
        ? relativeRotation(reference, device.orientation.heading)
        : device.layout.rotation;
    const originLayout = { ...device.layout, x: 0, y: 0, rotation };
    const originBounds = boundsForTiles([originLayout]);
    const layout = {
      ...originLayout,
      x: cursor - originBounds.minX,
      y: -originBounds.minY
    };
    cursor += originBounds.maxX - originBounds.minX + gap;
    return { deviceId: device.id, layout };
  });
}
